import "./ProgressCountdownTimer.scss";

import { Text } from "@fluentui/react-northstar";
import React from "react";

type Props = {
  percentComplete: number;
  secondsLeft: number;
};

export const ProgressCountdownTimer: React.FC<Props> = ({ percentComplete, secondsLeft }) => {
  const isGood = secondsLeft > 5;

  return (
    <div className="progress-countdown-timer">
      <div className="progress-countdown-timer__progress-bar">
        <div
          className={`progress-countdown-timer__progress-bar-fill ${
            isGood
              ? "progress-countdown-timer__progress-bar-fill-good"
              : "progress-countdown-timer__progress-bar-fill-warning"
          }`}
          style={{ width: `${percentComplete}%` }}
        />
      </div>

      <div
        className={`progress-countdown-timer__seconds ${
          isGood
            ? "progress-countdown-timer__seconds-good"
            : "progress-countdown-timer__seconds-warning"
        }`}
      >
        <Text content={secondsLeft.toString()} weight="bold" align="center" />
      </div>
    </div>
  );
};
